<template>
  <div>
    <div class="modelReg__title">
      <h3>{{ $t('modal.modalStateEnum.GoogleTowFA.title') }}</h3>
      <p>{{ $t('modal.modalStateEnum.GoogleTowFA.subTitle') }}</p>
    </div>
    <UForm class="modelReg__form">
      <UiBaseInputN
        v-model="form.twoFA"
        type-input="text"
        :label="$t('modal.modalStateEnum.GoogleTowFA.input')"
        :placeholder="$t('modal.modalStateEnum.GoogleTowFA.input')"
        :error="v$.twoFA.$error"
        :errors="v$.twoFA.$errors"
        :show-error="true"
        @change="v$.twoFA.$touch"
      ></UiBaseInputN>

      <UiBaseButton
        class="btn"
        size="xl"
        :label="$t('logout')"
        block
        type="submit"
        :disabled="v$.$invalid"
        @click.prevent="sendTwoFA"
      ></UiBaseButton>
    </UForm>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { useVuelidate } from '@vuelidate/core';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';
import { useRulesForForm } from '@shared/lib';

const { RulesForFormTwoFA } = useRulesForForm();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    }),
  },
});

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const form = ref(props.userData);

const rules = computed(() => {
  return {
    twoFA: RulesForFormTwoFA(),
  };
});
const v$ = useVuelidate(rules, form);

const sendTwoFA = async () => {
  const params = {
    twoFA: form.value.twoFA,
  };
  v$.value.$validate();
  if (!v$.value.$error) {
    // const twoFactorAuthenticationResult =
    // 	await apiAuth.twoFactorAuthentication(params);
    //
    // if (!twoFactorAuthenticationResult.error.value) {
    // storeModal.stateAuthModal(modalStateEnum.login);
    // }
  }
};
</script>


